export const USER_ID_SESSION_STORAGE = 'userId';

export const JWT_SESSION_STORAGE = 'jwt';

export const OTP_SESSION_STORAGE = 'otp';

export const ORG_SESSION_STORAGE = 'org';

export const USER_INFO_SESSION_STORAGE = 'userInfo';

export const ORG_INFO_SESSION_STORAGE = 'orgInfo';

export const XSTORE_MULTI_FILES = 'XSTORE_MULTI_FILES';

export const XSTORE_SINGLE_FILE = 'XSTORE_SINGLE_FILE';

export const XSTORE_FORMAT_MULTI_FILES =
	'Standard xStore format as multiple files, split by product code';

export const XSTORE_FORMAT_SINGLE_FILE =
	'Standard xStore format as a single file';

export const REP_EXTENSION = '.rep';

export const TXT_EXTENSION = '.txt';
